export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q05_a.6a472257.png";